import { Tooltip, Text, MantineSize, Card, Flex } from "@mantine/core"
import dayjs from "dayjs"
import { AbsentApprovalStatusBadge } from "./absent-approval-status-badge"
import { Property } from "../../-components/property"
import { RenderPeriod } from "./render-period"
import { useBreakpoints } from "../../utils/use-breakpoints"
import { AbsenceRequestViewmodel } from "../../@client/Theasoft_Absences"
import { PersonName } from "@components/PersonName"

export function PropertiesHeader({
  data,
  hideCreator,
  size,
}: {
  readOnly: boolean
  data: AbsenceRequestViewmodel
  hideCreator?: boolean
  size?: MantineSize
}) {
  const { xs } = useBreakpoints()
  return (
    <Card shadow="xs" style={{ overflow: "initial" }}>
      <Flex
        gap={"sm"}
        direction={xs ? "column" : "row"}
        justify={"space-between"}
        wrap={"wrap"}
      >
        {hideCreator ? null : (
          <Property
            size={size}
            label={"RequestedBy"}
            valueAsText
            children={
              data.workflow.createdByPersonId ? (
                <PersonName personId={data.workflow.createdByPersonId} />
              ) : null
            }
          />
        )}
        <Property
          size={size}
          label={"TimePeriod"}
          children={<RenderPeriod size={size} value={data.workflow.period} />}
        />
        <Property size={size} label="Reason" children={data.shiftTypeName} />
        <Property
          size={size}
          label={"RequestedAt"}
          valueAsText
          children={dayjs(data.workflow.createdAt).format("L LT")}
        />
        <Property
          size={size}
          label={"Comment"}
          children={
            <Tooltip label={data.workflow.comment} maw={300} multiline>
              <Text lineClamp={3}>{data.workflow.comment}</Text>
            </Tooltip>
          }
        />
        <Property
          size={size}
          label="OverallStatus"
          children={
            <AbsentApprovalStatusBadge
              status={data.workflow.result}
              variant="filled"
              size={size || "md"}
            />
          }
        />
      </Flex>
    </Card>
  )
}
